import React, {useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {getAnalysisModService, getAnalysisService} from "../../../services/app.service";
import {ANALYSIS_TYPES} from "../../../utils/constants";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

function CyberCompetenciesBreadthComp(props) {

    const {application_id, reload} = props;

    const [analysis, setAnalysis] = useState({});
    const [loading, setLoading] = useState(false);

    async function fetchAnalysis() {
        try {
            setLoading(true);
            const result = await getAnalysisService(application_id, ANALYSIS_TYPES.CYBER_COMPETENCIES_BREADTH);
            if(!result.error) {
                setAnalysis(result.data);
                console.log(result.data);
            }
            setLoading(false);
        }
        catch (e) {
            console.error(e);
            // already toasted the error
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAnalysis().then();
    }, [reload])

    return <>
        {/*<br/>*/}
        {/*    <Grid container spacing={2}>*/}
        {/*        <Grid item>*/}
        {/*            <TextField id='assumption1' variant="outlined" label={'Level 5 Coverage by'} value={analysis.assumption1 ? `${analysis.assumption1}%` : ""} InputProps={{readOnly: true}}/>*/}
        {/*        </Grid>*/}
        {/*        <Grid item>*/}
        {/*            <TextField id='assumption2' variant="outlined" label={'# of MB within Level 5'} value={analysis.assumption2 || ""} InputProps={{readOnly: true}}/>*/}
        {/*        </Grid>*/}
        {/*    </Grid>*/}
        {/*<br/>*/}
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Level 7</TableCell>
                        <TableCell>Topic</TableCell>
                        <TableCell>Cyber Competency</TableCell>
                        <TableCell>Covered</TableCell>
                        <TableCell>Aligned or not</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        analysis.data && analysis.data.map((item) =>
                           <TableRow>
                               <TableCell>{item.v3dqco_no}</TableCell>
                               <TableCell>{item.topic}</TableCell>
                               <TableCell>{item.cyber_competency}</TableCell>
                               <TableCell>{item.covered}</TableCell>
                               <TableCell>{item.aligned ? 'Yes' : 'No'}</TableCell>
                           </TableRow>
                        )
                    }
                </TableBody>
            </Table>
            <LoaderWithBackDrop loading={loading}/>
        </TableContainer>
    </>
}

export default CyberCompetenciesBreadthComp;